// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file dymensionxyz/dymension/rollapp/rollapp.proto (package dymensionxyz.dymension.rollapp, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { RollappMetadata } from "./metadata_pb.js";
import { GenesisInfo } from "./genesis_info_pb.js";
import { Coin } from "../../cosmos/base/v1beta1/coin_pb.js";
import { StateInfoIndex } from "./state_info_pb.js";

/**
 * RollappGenesisState is a partial repr of the state the hub can expect the
 * rollapp to be in upon genesis
 *
 * @generated from message dymensionxyz.dymension.rollapp.RollappGenesisState
 */
export class RollappGenesisState extends Message<RollappGenesisState> {
  /**
   * 0 means unpopulated
   * If populated, it's the proof height that the hub received the genesis transfer
   * packet from the rollapp. If populated, the bridge is considered open. It's not allowed
   * to fork to a height prior to this height.
   *
   * @generated from field: uint64 transfer_proof_height = 3;
   */
  transferProofHeight = protoInt64.zero;

  constructor(data?: PartialMessage<RollappGenesisState>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.RollappGenesisState";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 3, name: "transfer_proof_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RollappGenesisState {
    return new RollappGenesisState().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RollappGenesisState {
    return new RollappGenesisState().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RollappGenesisState {
    return new RollappGenesisState().fromJsonString(jsonString, options);
  }

  static equals(a: RollappGenesisState | PlainMessage<RollappGenesisState> | undefined, b: RollappGenesisState | PlainMessage<RollappGenesisState> | undefined): boolean {
    return proto3.util.equals(RollappGenesisState, a, b);
  }
}

/**
 * Rollapp defines a rollapp object. First, the RollApp is created and then
 * sequencers can be created and attached. The RollApp is identified by
 * rollappId
 *
 * @generated from message dymensionxyz.dymension.rollapp.Rollapp
 */
export class Rollapp extends Message<Rollapp> {
  /**
   * The unique identifier of the rollapp chain.
   * The rollapp_id follows the same standard as cosmos chain_id.
   *
   * @generated from field: string rollapp_id = 1;
   */
  rollappId = "";

  /**
   * owner is the bech32-encoded address of the rollapp owner.
   *
   * @generated from field: string owner = 2;
   */
  owner = "";

  /**
   * genesis_state is a partial repr of the state the hub can expect the rollapp
   * to be in upon genesis
   *
   * @generated from field: dymensionxyz.dymension.rollapp.RollappGenesisState genesis_state = 7;
   */
  genesisState?: RollappGenesisState;

  /**
   * channel_id will be set to the canonical IBC channel of the rollapp.
   *
   * @generated from field: string channel_id = 8;
   */
  channelId = "";

  /**
   * metadata is the rollapp metadata
   *
   * @generated from field: dymensionxyz.dymension.rollapp.RollappMetadata metadata = 11;
   */
  metadata?: RollappMetadata;

  /**
   * genesis_info keeps immutable rollapp fields
   *
   * @generated from field: dymensionxyz.dymension.rollapp.GenesisInfo genesis_info = 12;
   */
  genesisInfo?: GenesisInfo;

  /**
   * initial_sequencer is an option to preset one or more coma-separated
   * bech32-encoded addresses of the sequencer(s) that are allowed to initially
   * register and serve for this rollapp. if left empty, no sequencer is allowed
   * to register. if set to "*" any sequencer can register.
   *
   * @generated from field: string initial_sequencer = 13;
   */
  initialSequencer = "";

  /**
   * How much a sequencer needs to have at stake to be proposer be proposer.
   * Denom is dym. It is empty or ONE coin only. Coins is just a convenience to avoid
   * marshalling issues.
   *
   * @generated from field: repeated cosmos.base.v1beta1.Coin min_sequencer_bond = 20;
   */
  minSequencerBond: Coin[] = [];

  /**
   * vm_type is the type of rollapp machine: EVM or WASM
   *
   * @generated from field: dymensionxyz.dymension.rollapp.Rollapp.VMType vm_type = 14;
   */
  vmType = Rollapp_VMType.Unspecified;

  /**
   * launched is a boolean that indicates that the Rollapp has been launched and
   * the immutable fields are no longer updatable.
   *
   * @generated from field: bool launched = 15;
   */
  launched = false;

  /**
   * pre_launch_time is the timestamp indicating the time before which the
   * rollapp cannot be started.
   * Set when creating IRO plan for the rollapp
   *
   * @generated from field: google.protobuf.Timestamp pre_launch_time = 16;
   */
  preLaunchTime?: Timestamp;

  /**
   * LivenessEventHeight is the height on the HUB of an upcoming liveness event (slash or
   * jail against the rollapp). 0 means not set
   *
   * @generated from field: int64 liveness_event_height = 17;
   */
  livenessEventHeight = protoInt64.zero;

  /**
   * The height on the HUB that we start counting liveness from. If the rollapp is not active
   * for a long time after this height, a liveness event will happen.
   *
   * @generated from field: int64 liveness_countdown_start_height = 18;
   */
  livenessCountdownStartHeight = protoInt64.zero;

  /**
   * Revisions is a list of all the rollapp revisions.
   *
   * @generated from field: repeated dymensionxyz.dymension.rollapp.Revision revisions = 19;
   */
  revisions: Revision[] = [];

  constructor(data?: PartialMessage<Rollapp>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.Rollapp";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "genesis_state", kind: "message", T: RollappGenesisState },
    { no: 8, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "metadata", kind: "message", T: RollappMetadata },
    { no: 12, name: "genesis_info", kind: "message", T: GenesisInfo },
    { no: 13, name: "initial_sequencer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "min_sequencer_bond", kind: "message", T: Coin, repeated: true },
    { no: 14, name: "vm_type", kind: "enum", T: proto3.getEnumType(Rollapp_VMType) },
    { no: 15, name: "launched", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "pre_launch_time", kind: "message", T: Timestamp },
    { no: 17, name: "liveness_event_height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 18, name: "liveness_countdown_start_height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 19, name: "revisions", kind: "message", T: Revision, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Rollapp {
    return new Rollapp().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Rollapp {
    return new Rollapp().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Rollapp {
    return new Rollapp().fromJsonString(jsonString, options);
  }

  static equals(a: Rollapp | PlainMessage<Rollapp> | undefined, b: Rollapp | PlainMessage<Rollapp> | undefined): boolean {
    return proto3.util.equals(Rollapp, a, b);
  }
}

/**
 * @generated from enum dymensionxyz.dymension.rollapp.Rollapp.VMType
 */
export enum Rollapp_VMType {
  /**
   * @generated from enum value: Unspecified = 0;
   */
  Unspecified = 0,

  /**
   * @generated from enum value: EVM = 1;
   */
  EVM = 1,

  /**
   * @generated from enum value: WASM = 2;
   */
  WASM = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(Rollapp_VMType)
proto3.util.setEnumType(Rollapp_VMType, "dymensionxyz.dymension.rollapp.Rollapp.VMType", [
  { no: 0, name: "Unspecified" },
  { no: 1, name: "EVM" },
  { no: 2, name: "WASM" },
]);

/**
 * Revision is a representation of the rollapp revision.
 *
 * @generated from message dymensionxyz.dymension.rollapp.Revision
 */
export class Revision extends Message<Revision> {
  /**
   * Number is the revision number of the rollapp. Always start with 0 revision.
   *
   * @generated from field: uint64 number = 19;
   */
  number = protoInt64.zero;

  /**
   * StartHeight is the first height of the rollapp when the revision started.
   *
   * @generated from field: uint64 start_height = 20;
   */
  startHeight = protoInt64.zero;

  constructor(data?: PartialMessage<Revision>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.Revision";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 19, name: "number", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 20, name: "start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Revision {
    return new Revision().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Revision {
    return new Revision().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Revision {
    return new Revision().fromJsonString(jsonString, options);
  }

  static equals(a: Revision | PlainMessage<Revision> | undefined, b: Revision | PlainMessage<Revision> | undefined): boolean {
    return proto3.util.equals(Revision, a, b);
  }
}

/**
 * Rollapp summary is a compact representation of Rollapp
 *
 * @generated from message dymensionxyz.dymension.rollapp.RollappSummary
 */
export class RollappSummary extends Message<RollappSummary> {
  /**
   * The unique identifier of the rollapp chain.
   * The rollappId follows the same standard as cosmos chain_id.
   *
   * @generated from field: string rollappId = 1;
   */
  rollappId = "";

  /**
   * Defines the index of the last rollapp UpdateState.
   *
   * @generated from field: dymensionxyz.dymension.rollapp.StateInfoIndex latestStateIndex = 2;
   */
  latestStateIndex?: StateInfoIndex;

  /**
   * Defines the index of the last rollapp UpdateState that was finalized.
   *
   * @generated from field: dymensionxyz.dymension.rollapp.StateInfoIndex latestFinalizedStateIndex = 3;
   */
  latestFinalizedStateIndex?: StateInfoIndex;

  /**
   * TODO:
   *
   * @generated from field: uint64 latestHeight = 4;
   */
  latestHeight = protoInt64.zero;

  /**
   * TODO:
   *
   * @generated from field: uint64 latestFinalizedHeight = 5;
   */
  latestFinalizedHeight = protoInt64.zero;

  constructor(data?: PartialMessage<RollappSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.RollappSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rollappId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "latestStateIndex", kind: "message", T: StateInfoIndex },
    { no: 3, name: "latestFinalizedStateIndex", kind: "message", T: StateInfoIndex },
    { no: 4, name: "latestHeight", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "latestFinalizedHeight", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RollappSummary {
    return new RollappSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RollappSummary {
    return new RollappSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RollappSummary {
    return new RollappSummary().fromJsonString(jsonString, options);
  }

  static equals(a: RollappSummary | PlainMessage<RollappSummary> | undefined, b: RollappSummary | PlainMessage<RollappSummary> | undefined): boolean {
    return proto3.util.equals(RollappSummary, a, b);
  }
}

